import { sectionCls } from '@/pages/launch/helpers';
import LaunchWaitlistForm from './launch-waitlist-form';

interface LaunchFinalCtaSectionProps {
  sectionRef: React.Ref<HTMLDivElement>;
  visible: boolean;
  footerEmail: string;
  setFooterEmail: (email: string) => void;
  footerSubmitted: boolean;
  footerLoading: boolean;
  onSubmitFooter: () => void;
}

const LaunchFinalCtaSection = ({
  sectionRef,
  visible,
  footerEmail,
  setFooterEmail,
  footerSubmitted,
  footerLoading,
  onSubmitFooter,
}: LaunchFinalCtaSectionProps) => (
  <section
    ref={sectionRef}
    className={`py-12 sm:py-20 px-4 sm:px-6 bg-gradient-to-b from-primary/10 via-primary/5 to-background ${sectionCls(visible)}`}
  >
    <div className="max-w-3xl mx-auto text-center">
      <h2 className="text-3xl sm:text-4xl font-display font-bold mb-4">
        Every Night Without Data Is Another Night{' '}
        <span className="gradient-text">You're Guessing.</span>
      </h2>
      <p className="text-muted-foreground mb-8">
        We're selecting 5 founding venues to shape the platform. White-glove setup, 90 days free,
        direct founder access.
      </p>
      <div className="max-w-lg mx-auto">
        <LaunchWaitlistForm
          email={footerEmail}
          setEmail={setFooterEmail}
          submitted={footerSubmitted}
          loading={footerLoading}
          onSubmit={onSubmitFooter}
          submittedMessage="You're in \u2014 we'll reach out within 48 hours."
        />
      </div>
    </div>
  </section>
);

export default LaunchFinalCtaSection;
